import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lyceo-ui-more-menu-note',
  templateUrl: './more-menu-note.component.html',
  styleUrls: ['./more-menu-note.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreMenuNoteComponent {}
